module.exports = __webpack_public_path__ + "static/scopriabitareco_hero-20cad9103fe83ea0a62af984eed9d3c0.jpg";